module.exports = function (object, cb, context) {
  var newObject = {}
  for (var key in object) {
    if (!object.hasOwnProperty(key)) {
      continue;
    }
    newObject[key] = cb.call(context, object[key], key, object);
  }
  return newObject;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/object-map/index.js
// module id = 473
// module chunks = 0